import React from 'react'
import PropTypes from 'prop-types'

import styles from './Checkbox.module.scss'
import { ReactComponent as CheckmarkIcon } from '../assets/icons/checkmark-icon.svg'

const Checkbox = ({ label, name, handleChange, checked }) => {
  return (
    <label className={styles.customCheckbox}>
      <span className={styles.customCheckbox__label}>
        {label}
      </span>
      <input
        type="checkbox"
        name={name}
        className={styles.customCheckbox__checkbox}
        checked={checked}
        onChange={handleChange}
      />
      <span className={styles.customCheckbox__checkmark}>
        <CheckmarkIcon className={styles.customCheckbox__checkmarkIcon} />
      </span>
    </label>
  )
}

Checkbox.propTypes = {
 label: PropTypes.string,
 name: PropTypes.string,
 checked: PropTypes.bool,
 handleChange: PropTypes.func,
}

Checkbox.defaultProps = {
  checked: false
}

export default Checkbox
